import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import MobileSidebarNavItemContainer from './MobileSidebarNavItemContainer';

import { useSidebarStore } from '../_useSidebarStore';
import { SIDEBAR_WIDTH } from '@/shared/constants';

import type { SidebarMenuItem } from '../types';

interface GlobalSidebarProps {
  menu: SidebarMenuItem[];
}

/**
 * 모바일(Capacitor) 셸 전용 사이드바 (표시할 메뉴는 상위에서 주입).
 * 앱은 폰 전용이라 항상 왼쪽 드로어로만 동작한다 — 데스크톱 GlobalSidebar(레일 확장/축소)와는 별개.
 */
export default function MobileGlobalSidebar({ menu }: GlobalSidebarProps) {
  const isMobileDrawerOpen = useSidebarStore((s) => s.isMobileDrawerOpen);
  const setMobileDrawerOpen = useSidebarStore((s) => s.setMobileDrawerOpen);
  const location = useLocation();

  // 라우트 변경 시 드로어 닫기
  useEffect(() => {
    setMobileDrawerOpen(false);
  }, [location.pathname]);

  // 드로어 열릴 때 body 스크롤 잠금
  useEffect(() => {
    document.body.style.overflow = isMobileDrawerOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobileDrawerOpen]);

  return (
    <>
      {/* 백드롭 — 드로어 열릴 때만 */}
      {isMobileDrawerOpen && <div className='fixed inset-0 z-[49] bg-black/40' onClick={() => setMobileDrawerOpen(false)} aria-hidden='true' />}

      <S.Aside $open={isMobileDrawerOpen} className='custom_scroll'>
        <MobileSidebarNavItemContainer menu={menu} />
      </S.Aside>
    </>
  );
}

// --- --- --- Styled Components --- --- --- //
const S = {
  Aside: styled.aside<{ $open: boolean }>`
    position: fixed;
    /* AppTopBar의 실제 높이(--header-h)와 반드시 같은 값이어야 어긋나지 않는다 */
    top: var(--header-h, calc(var(--nav-h, 0px) + env(safe-area-inset-top)));
    left: 0;
    bottom: 0;
    width: ${SIDEBAR_WIDTH.EXPANDED};
    z-index: 50;
    overflow: hidden;
    font-family: 'Pretendard';
    background: var(--color-basic-white, #fff);
    transform: translateX(${({ $open }) => ($open ? '0' : '-100%')});
    transition: transform 0.3s ease;
  `,
};
